import { TNetworkIdentifier } from 'src/common/models/networkIdentifier';

/**
 * Generates a link to the social account
 * @param network Social network
 * @param username Username
 */
export const getSocialAccountLink = (network: TNetworkIdentifier, username: string): string | undefined => {
  if (!username) {
    return undefined;
  }
  switch (network) {
    case 'blog':
      return username; // usually the site URL
    case 'facebook':
      return `https://facebook.com/${username}`;
    case 'instagram':
      return `https://instagram.com/${username}`;
    case 'pinterest':
      return `https://pinterest.com/${username}`;
    case 'snapchat':
      return `https://snapchat.com/add/${username}`;
    case 'tiktok':
      return `https://tiktok.com/@${username}`;
    case 'twitch':
      return `https://twitch.tv/${username}`;
    case 'twitter':
      return `https://twitter.com/${username}`;
    case 'youtube':
      return `https://youtube.com/${username}`;
    default:
      return undefined;
  }
};
